export const cacheSortOptions = [
  {id: 'accessed-desc', text: 'Recently used'},
  {id: 'accessed-asc', text: 'Least recently used'},
  {id: 'created-desc', text: 'Newest'},
  {id: 'created-asc', text: 'Oldest'},
  {id: 'size-desc', text: 'Largest size'},
  {id: 'size-asc', text: 'Smallest size'},
]
